import { AiOutlineEdit, AiOutlineDelete, AiOutlineFileMarkdown, AiOutlineFilePdf, AiOutlineCalendar, AiOutlineCopy, AiOutlineExport, AiOutlineBank } from "react-icons/ai"
import { FaHashnode } from "react-icons/fa6"
import { PiTreeStructureLight } from "react-icons/pi"

const CONSTANT = {
  SESSION_CREDENTIALS: 'Session-Credentials'
}

export {
  CONSTANT
}

export const Actions = {
    UPDATE: 'update',
    DELETE: 'delete',
    SOURCE: 'source',
    SCRIPT: 'script',
    DATA_MAPPING: 'datamapping',
    DEPARTMENT: 'department',
    PDF_BUILDER: 'pdfbuilder',
    SCHEDULE: 'schedule',
    UNSCHEDULE: 'unschedule',
    COPY: 'copy',
    EXPORT: 'export',
    COURT: 'court',
}

export const workflowTypes = [
    { value: 'TRAFFIC', label: 'Traffic' },
    { value: 'PARKING', label: 'Parking' },
    { value: 'MISDEMEANOR', label: 'Misdemeanor' },
    { value: 'FEDERAL', label: 'Federal' },
    { value: 'FIRE_ENFORCEMENT', label: 'Fire Enforcement' }
]

export const producerTypes = [
    { value: 'ALL', label: 'All' },
    { value: 'EXPORT', label: 'Export' },
    { value: 'TRANSMIT', label: 'Transmit' }
]

export const incidentTypes = [
    { value: 'ALL', label: 'All' },    
    { value: 'CITATION', label: 'Citation' },
    { value: 'WARNING', label: 'Warning' }
]

export const ClientActionMenu = {
    updateMenu: {
        key: 'update',
        icon: <AiOutlineEdit />,
        label: 'Update Client'
    },
    deleteMenu: {
        key: 'delete',
        icon: <AiOutlineDelete />,
        label: 'Delete Client'
    },
    sourceDataMenu: {
        key: 'source',
        icon: <AiOutlineFileMarkdown />,
        label: 'Source Data'
    },
    dataMappingMenu: {
        key: 'datamapping',
        icon: <PiTreeStructureLight />,
        label: 'Open Data Mapping'
    },
    departmentMenu: {
        key: 'department',
        icon: <FaHashnode />,
        label: 'Set Department Mapping'
    },
    courtMenu: {
        key: 'court',
        icon: <AiOutlineBank />,
        label: 'Set Court Mapping'
    },
    scriptEditorMenu: {
        key: 'script',
        icon: <AiOutlineFileMarkdown />,
        label: 'Script Editor'
    },
    pdfBuilderMenu: {
        key: 'pdfbuilder',
        icon: <AiOutlineFilePdf />,
        label: 'Open PDF Builder'
    },
    scheduleMenu: {
        key: 'schedule',
        icon: <AiOutlineCalendar />,
        label: 'Schedule Transmission'
    },
    unscheduleMenu: {
        key: 'unschedule',
        icon: <AiOutlineCalendar />,
        label: 'Stop Scheduled Transmission'
    },
    copyMenu: {
        key: 'copy',
        icon: <AiOutlineCopy />,
        label: 'Create Copy'
    },
    exportMenu: {
        key: 'export',
        icon: <AiOutlineExport />,
        label: 'Export Client'
    },
}